export class LoginSectionModel {
  desc1: number;
  desc2: string;
  contact: string;
  contact_tty: string;
  button_name: string;
  button_link: string;
  button_link_test: string;

  constructor() {
    this.desc1 = undefined;
    this.desc2 = undefined;
    this.contact = undefined;
    this.contact_tty = undefined;
    this.button_name = undefined;
    this.button_link = undefined;
    this.button_link_test = undefined;
  }
}
